var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.info)?_c('v-chip',{staticClass:"late-badge",attrs:{"x-small":"","color":_vm.info.level === 'late' ? 'error' : 'warning',"title":_vm.title}},[_c('v-icon',{attrs:{"x-small":"","left":""}},[_vm._v("mdi-timer-alert-outline")]),_vm._v(_vm._s(_vm.label)+" ")],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }